import contextBasedEnvironments from "./contextBasedEnvironments";

export default () =>
	[
		{include: 'localhost', target: contextBasedEnvironments.LOCAL},
		{include: 'dev', target: contextBasedEnvironments.DEV},
		{include: 'test', target: contextBasedEnvironments.TEST},
		{include: '', target: contextBasedEnvironments.PROD}
	]
		.filter(environment => document.location.hostname.includes(environment.include))
		.shift()
		.target;
